import { getTranslation } from '@easy-expense/intl-client';

import { Survey } from '../../components/OnboardingFlow/Survey/Survey';

export const BusinessTypeSurvey: React.FC<{
  setUsageOptions: (options: string[]) => void;
  selectedOptions: string[];
}> = ({ setUsageOptions, selectedOptions }) => {
  return (
    <Survey
      header={getTranslation(`Lets customize Easy Expense to maximize your deductions`)}
      text={getTranslation('Select all that apply so we can ensure the best experience for you!')}
      options={[
        {
          title: getTranslation('Business Owner'),
          success: getTranslation(
            'Business owners find an average of $2,192 in deductions within 5 minutes of using Easy Expense',
          ),
        },
        {
          title: getTranslation('Freelancer'),
          success: getTranslation(
            'Perfect! Easy Expense saves 100s of hours per year by automatically reconciling receipts and bank statements.',
          ),
        },
        {
          title: getTranslation('Employee'),
          success: getTranslation(
            'Perfect! Generate professional PDF reports in seconds to get reimbursed faster.',
          ),
        },
      ]}
      multiSelect={false}
      onOptionSelected={(options: string[]) => setUsageOptions(options)}
      selectedOptions={selectedOptions}
    />
  );
};
